<div class="w-full mb-4 bg-white rounded-md">
  <div class="p-4 bg-white rounded-md shadow border border-gray-200">
    <h3 class="text-base md:text-lg font-medium text-center text-[#c19725] mb-4">
      Add New Sub Category(ReadyProduct)
    </h3>

    <form [formGroup]="subCategoryForm" (ngSubmit)="addSubCategory()">
      <div class="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-2.5 md:gap-3">

        <!-- Category type -->
        <select formControlName="category_id" class="col-span-2 px-2 py-2 border border-gray-300 rounded-md shadow-sm
                 focus:outline-none focus:ring-2 focus:ring-[#c19725]
                 focus:border-[#c19725] text-sm">
          <option value="" selected disabled hidden>Select Category</option>
          <option *ngFor="let category of prodCategory" [value]="category.id">
            {{ category.name }} (#{{ category.unit}})
          </option>
        </select>

        <!-- Category Name -->
        <input type="text" formControlName="name" autocomplete="off" placeholder="Enter new sub category name" class="col-span-2 px-2 py-2 border border-gray-300 rounded-md shadow-sm
                 focus:outline-none focus:ring-2 focus:ring-[#c19725]
                 focus:border-[#c19725] text-sm" />

        <!-- Category Unit -->
        <input readonly type="text" formControlName="category_unit" autocomplete="off" placeholder="Category Unit" class="col-span-2 px-2 py-2 border border-gray-300 rounded-md shadow-sm
                 focus:outline-none focus:ring-2 focus:ring-[#c19725]
                 focus:border-[#c19725] text-sm" />

       <div class="col-span-2 sm:col-span-4 lg:col-span-6 flex items-center justify-center gap-3">
         <!-- Submit -->
        <button type="submit" *ngIf="!isEditMode" class="block cursor-pointer capitalize w-max
         py-1 md:py-1.5 px-2 text-base xl:text-lg font-bold
         text-white bg-c19725 border-1 border-c19725
         hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg
         focus:ring-0 focus:outline-none rounded-md text-center">
          Add
        </button>

        <!-- Update -->
        <button type="submit" *ngIf="isEditMode" class="block cursor-pointer capitalize w-20
         py-1 md:py-1.5 px-2 text-base xl:text-lg font-bold
         text-white bg-c19725 border-1 border-c19725
         hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg
         focus:ring-0 focus:outline-none rounded-md text-center">
          Update
        </button>

        <!-- Clear -->
        <button type="button" (click)="clearForm()" class="block cursor-pointer capitalize w-max
         py-1 md:py-1.5 px-2 text-base xl:text-lg font-bold
         text-white bg-c19725 border-1 border-c19725
         hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg
         focus:ring-0 focus:outline-none rounded-md text-center">
          Clear
        </button>
       </div>

      </div>
    </form>
  </div>
  <div class="w-full py-3 px-2 lg:px-4">
    <p class="font-semibold text-sm sm:text-base lg:text-xl text-444 mb-4">Category List</p>

    <div class="overflow-x-auto whitespace-nowrap hide-scrollbar mt-4">
      <table class="w-full table bg-white border border-[#D9D9D9] overflow-hidden">
        <thead class="bg-[#F1F8FF] border border-[#0C447D] text-444 text-xs sm:text-xs">
          <tr>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">No.</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Sub Category Name</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Category Name</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Category Unit</th>
            <th class="p-2 font-medium text-center border-r border-[#0C447D]">Action
          </tr>
        </thead>
        <tbody class="text-xs sm:text-xs">
          <tr *ngFor="let subCategory of paginatedSubCategories; let i = index"
            class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]">
            <td class="p-3 text-center">{{ (currentPage - 1) * itemsPerPage + (i + 1) }}</td>
            <td class="p-3 text-center">{{ subCategory.name }}</td>
            <td class="p-3 text-center">{{ subCategory.category.name }}</td>
            <td class="p-3 text-center">{{ subCategory.category_unit }}</td>
            <td class="p-3 text-center">
              <div class="flex items-center justify-center gap-3">

                <!-- View/Edit Button -->
                <button class="cursor-pointer" (click)="editSubCategory(subCategory)">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                      stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.7166 9.23962L8.10638 15.8499" stroke="#C19725" stroke-miterlimit="5"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>

                <button aria-label="Delete Category"
                  class="icon-btn text-[#BB0000] hover:scale-110 hover:text-[#990000]" title="Delete Category"
                  (click)="deleteSubCategory(subCategory.id)">
                  <svg class="w-5 h- md:w-6 md:h-6" fill="none" viewBox="0 0 24 25">
                    <path d="M10 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M14 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M4 7.5H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="flex justify-center items-center gap-3 mt-4">

        <!-- Previous -->
        <button (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1"
          class="px-3 py-1 border rounded disabled:opacity-40">
          Previous
        </button>

        <!-- Page Numbers -->
        <ng-container *ngFor="let page of [].constructor(totalPages); let p = index">
          <button (click)="currentPage = p + 1" [class.bg-[#c19725]]="currentPage === p + 1"
            [class.text-white]="currentPage === p + 1" class="px-3 py-1 border rounded">
            {{ p + 1 }}
          </button>
        </ng-container>

        <!-- Next -->
        <button (click)="currentPage = currentPage + 1" [disabled]="currentPage === totalPages"
          class="px-3 py-1 border rounded disabled:opacity-40">
          Next
        </button>

      </div>
    </div>
  </div>
</div>